import Axios from "axios";
import * as config from "@/constants/config";
import { authHeader } from "@/services/TokenHelper";

export default {
  controller: "users/",
  requests: "requests/",
  accesses: "/accesses",
  GetAllUsers: function() {
    return Axios.get(config.API + this.controller, { headers: authHeader() });
  },
  UpdateUser: function(updatedUser) {
    return Axios.put(
      config.API + this.controller + updatedUser.user.id,
      updatedUser,
      { headers: authHeader() }
    );
  },
  GetUserProfile: function(userId = 0) {
    return Axios.get(config.API + this.controller + userId, {
      headers: authHeader()
    });
  },
  GetUserAccesses: function(userId = 0) {
    return Axios.get(config.API + this.controller + userId + this.accesses, {
      headers: authHeader()
    });
  }
};
